import React from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routes, routeFor } from 'src/core/constants/routes';
import { useAccessibleCardsLinks } from 'src/core/pages/CardsPage/CardsPage';

import { NavLink } from '../NavLink/NavLink';

type Props = {
  company: {
    id: string;
  };
};

export const CardLink = ({ company }: Props) => {
  const { t } = useTranslation('global');
  const cardsLinks = useAccessibleCardsLinks();

  return (
    <NavLink
      href={routeFor(cardsLinks[0].path, { company: company.id })}
      iconName="card"
      activePaths={[
        routes.SUBSCRIPTIONS.path,
        routes.SUBSCRIPTIONS_TRANSACTION_DETAILS.path,
        routes.CARD.path,
        routes.CARD_TRANSACTION_DETAILS.path,
        routes.CARDS.path,
        routes.CARDS_TRANSACTION_DETAILS.path,
        routes.MULTI_USE_CARDS.path,
        routes.MULTI_USE_CARDS_TRANSACTION_DETAILS.path,
      ]}
    >
      {t('misc.card_plural')}
    </NavLink>
  );
};
